import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {Navigation} from '@homeaway/react-navigation';

import StickyBarCss from '../StickyBarCss/StickyBarCss';
import SearchBox from "../SearchBox/SearchBox";
import Modal from '../Modal/Modal';
import TabbedContent from "../TabbedContent/TabbedContent";
import SearchInput from '../SearchInput/SearchInput';
import CssStickyBarsBase from '../CssStickyBarsBase/CssStickyBarsBase';

import './CssStickyBars.less';

export default class CssStickyBars extends CssStickyBarsBase {
    static propTypes = {
        imageHeight: PropTypes.string,
        spacerHeight: PropTypes.string
    }

    constructor(props) {
        super(props);

        this.state = {
            searchHeight: 0,
            searchTop: 0,
            searchIsSticky: 0,
            navHeight: 0,
            navTop: 0,
            navIsSticky: 0,
            visible: 0,
            activeIndex: 0,
            scrollingFromClick: false
        }

        this.ref = React.createRef();
        this.removeScrollHandler = null;
        this.timeouts = {};
        this.contentElemsPos = this.props.contentElemsPos || [500, 1722, 2842];
        
        // flag to console log
        this.doLog = false;
    }

    getContentElemPadding() {
        const {searchHeight, navHeight} = this.state;
        return searchHeight + navHeight;
    }

    render() {
        const {searchIsSticky, navIsSticky, visible, activeIndex, searchHeight} = this.state;
        const {imageHeight, spacerHeight} = this.props;
        const searchStickyBarClasses = classnames('sticky-bar-css--searchbox', {
            'sticky-bar-css--searchbox-sticky-nav-sticky': searchIsSticky && navIsSticky
        });

        return (
            <div className="CssStickyBars" ref={this.ref} onTouchStart={this.onTouchStart}>
                <Modal toggleModal={this.closeModal} visible={visible}>
                    <SearchBox closeModal={this.closeModal}/>
                </Modal>
                <div className="searchbox-area"
                    style={{height: imageHeight}}
                />

                <h1 className="searchbox-area__main-title text-inverse">
                    {'Villa? Cottage?'}<br/>{'Apartment?'}
                </h1>
                <h2 className="searchbox-area__sub-title text-inverse">
                    {'Your perfect holiday awaits'}
                </h2>
                
                <StickyBarCss
                    className={searchStickyBarClasses}
                    onStickyChange={this.onSearchStickyChange}
                    onSetElemHeight={this.onSetSearchHeight}
                    onSetElemTop={this.onSetSearchTop}
                    top={0}
                    name="css-sticky-search"
                >
                    <SearchInput
                        onClick={this.openModal}
                        placeholder={this.props.placeholder}
                    />
                </StickyBarCss>
                <div
                    style={{
                        width: '100%',
                        height: spacerHeight
                    }}
                />
                <StickyBarCss
                    className="sticky-bar-css--nav"
                    top={searchHeight}
                    onStickyChange={this.onNavStickyChange}
                    onSetElemHeight={this.onSetNavHeight}
                    name="css-sticky-nav"
                >
                    <Navigation
                        noMobileSelect
                        leftAlign={false}
                        activeIndex={activeIndex}
                        onLinkClick={this.handleNavTabs}
                        links={this.props.links}
                    />
                </StickyBarCss>
                <TabbedContent onContentLoaded={this.onContentImagesLoaded} />
            </div>
        );
    }
}